import * as React from 'react';
import { Link } from '../link/link';
import { TSeoUrls } from '../../types/seoUrls';

import * as styles from './SeoUrlsBlock.css';

interface ISeoUrlsBlockProps {
  links: TSeoUrls;
}

export const SeoUrlsBlock = (props: ISeoUrlsBlockProps) => (
  <div className="cg-col-5 cg-skip-1">
    <h4 className={styles['c-new-on-cian-title']}>Новое на ЦИАН</h4>
    {props.links.map((link: TSeoUrls[number], i: number) => (
      <div key={`new_seo_link_${i}`} className={styles['c-new-on-cian-link-item']}>
        <Link href={link.url}>{link.anchor}</Link>
      </div>
    ))}
  </div>
);
